import { useMutation } from '@tanstack/react-query';
import { ILoginResponse } from "../../utils/types";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useLogin = () =>
  useMutation({
    mutationFn: async ({ email, password }: { email: string; password: string }): Promise<ILoginResponse> => {
      const res = await apiClient.post(ENDPOINTS.AUTH.LOGIN, {
        email,
        password

      });
      return res.data;
    },
  });